/**
 * Official Neyra logo wrapper.
 * IMPORTANT: Per brand rules, the logo image must NOT be modified or have any
 * background added. We render the image file as-is.
 */
const Logo = ({ size = 96, className = "", alt = "Neyra" }) => {
    return (
        <img
            src="/logo.png"
            alt={alt}
            width={size}
            height={size}
            className={className}
            style={{ width: size, height: size, objectFit: "contain", display: "block" }}
            draggable={false}
            data-testid="neyra-logo"
        />
    );
};

export default Logo;
